"use client";
import { useState } from "react";
import CoreImage from "../CoreImage/CoreImage";
import GallerySlider from "./GallerySlider";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

const Gallery = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initImageIndex, setInitImageIndex] = useState(0);
  const innerBlocks = data?.innerBlocks || [];
  if (!innerBlocks.length) return null;

  const parent_attrs = {
    block_name: data?.blockName,
    ...data?.attrs,
  };

  return (
    <section className="flex flex-wrap gap-6 max-w-app mx-auto mb-14 md:mb-20 px-4 xl:px-0">
      {innerBlocks.map((block, index) => {
        const id = block?.attrs?.id ?? index;
        const withParent = { ...block, parent_attrs };

        return (
          <CoreImage
            key={id}
            data={withParent}
            isGallery
            openImage={() => { setIsOpen(true); setInitImageIndex(index); }}
          />
        );
      })}

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-[999]">
        <DialogBackdrop transition className="fixed inset-0 bg-[#263439]/90 duration-300 ease-out data-[closed]:opacity-0" />
        <div className="fixed inset-0 flex items-center justify-center w-screen px-4 py-12 md:p-20">
          <DialogPanel transition className="max-w-[calc(100vw-2rem)] md:max-w-[calc(100vw-10rem)] xl:max-w-container space-y-4 bg-transparent duration-300 ease-out data-[closed]:scale-95 data-[closed]:opacity-0">
            <GallerySlider images={innerBlocks} clickedImage={initImageIndex} isOpen={isOpen} />
          </DialogPanel>
        </div>
      </Dialog>
    </section>
  );
};

export default Gallery;
